import styled from 'styled-components';

type CollapsableListProps = {
  isCollapsed: boolean;
};

export const MainTrackPresentationContainer = styled.div`
  margin-top: 72px;
  display: flex;
  align-items: flex-start;
  gap: 32px;
  div {
    flex: 50%;
  }
`;

export const TrackDescriptionContainer = styled.div`
  padding: 24px 24px 0px 24px;
  background: #282828;
`;

export const ListContainer = styled.div<CollapsableListProps>`
  max-height: ${(props) => (props.isCollapsed ? '360px' : '720px')};
  overflow-y: ${(props) => (props.isCollapsed ? 'hidden' : 'scroll')};
`;

export const ListRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const ExternalLink = styled.a`
  text-decoration: none;
  color: #ea6343;
`;

export const OwnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  font-size: 16px;
`;

export const OwnedIndex = styled.span`
  font-size: 16px;
  line-height: 24px;

  color: #ffffff;
`;

export const ViewAllButton = styled.button`
  margin: 0 auto;
  margin-bottom: 24px;
  width: 100%;
  font-family: 'MabryPro';
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff;
  border: none;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }
`;
